import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { INVITATION } from "../../../api/Invitation";
import ThemeOne from "../../../components/auth/invitation/ThemeOne/ThemeOne";
import ThemeTwo from "../../../components/auth/invitation/ThemeTwo/ThemeTwo";
export default function Invitation() {
  const { couple, date } = useParams();
  const [data, setData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const toggleAudio = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play().catch((err) => {
        // console.log("Autoplay failed:", err);
      });
      setIsPlaying(true);
    }
  };
  const getDetails = async (req) => {
    try {
      const res = await INVITATION.GET_BY_DATA(req);
      if (res.status !== 200) {
        throw new Error("Failed to fetch brand information");
      }
      setData(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };
  useEffect(() => {
    const [bride, groom] = couple.split("-");
    const req = { bride: bride, groom: groom, date: date };
    getDetails(req);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couple, date]);

  const audioRef = useRef(null);

  useEffect(() => {
    const playAudio = () => {
      audioRef.current.play().catch((err) => {
        // console.log("Autoplay failed:", err);
      });
      setIsPlaying(true);
    };

    // Play after first user interaction
    window.addEventListener("click", playAudio, { once: true });

    return () => {
      window.removeEventListener("click", playAudio);
    };
  }, []);

  return (
    <div>
      {data !== null ? (
        <>
          {data !== undefined ? (
            <div className="relative bg-hero">
              {data.theme === "Theme 1" && <ThemeOne data={data} />}
              {data.theme === "Theme 2" && <ThemeTwo data={data} />}
              {data.addMusic && (
                <audio ref={audioRef} loop>
                  <source src={`/music/${data.music}`} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              )}
              {data.addMusic && (
                <div className="bg-white gap-1 h-11 px-1 flex justify-center items-center rounded-full fixed bottom-2 right-2">
                  <img
                    src="https://static.thenounproject.com/png/636551-200.png"
                    alt="pause"
                    className="w-10 h-10"
                  />
                  {isPlaying ? (
                    <button onClick={toggleAudio}>
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/61/61180.png"
                        alt="pause"
                        className="w-10 h-10"
                      />
                    </button>
                  ) : (
                    <button onClick={toggleAudio}>
                      <img
                        src="https://static.vecteezy.com/system/resources/thumbnails/035/753/221/small_2x/video-play-button-icon-for-graphic-design-logo-web-site-social-media-mobile-app-ui-illustration-png.png"
                        alt="play"
                        className="w-10 h-10"
                      />
                    </button>
                  )}
                </div>
              )}
            </div>
          ) : (
            <>
              <p>No Data found</p>
            </>
          )}
        </>
      ) : (
        <>
          <p>Loading...</p>
        </>
      )}
    </div>
  );
}
